import { addWeeks } from "date-fns";

/**
 * Derives the (read-only) end date for a duplicated menu from its start date and
 * the selected number of weeks. A 1-week menu ends on its start date, so the end
 * date is the start date plus (weeks - 1) weeks.
 */
export const deriveDuplicateEndDate = (startDate: Date, weeks: number): Date => addWeeks(startDate, weeks - 1);
